import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useOrders } from '../context/OrderContext';
import { useNavigate, Navigate } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { isAuthenticated, logout } = useAuth();
  const { orders: realOrders, updateOrderStatus, deleteOrder } = useOrders();
  const [activeTab, setActiveTab] = useState('books');
  const [books, setBooks] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  // Sample data - in real app, this would come from API
  useEffect(() => {
    setBooks([
      { id: 1, title: 'كتاب الأدب العربي', author: 'أحمد محمد', price: 150, image: '/api/placeholder/200/250', category: 'أدب', description: 'كتاب شامل عن الأدب العربي الكلاسيكي والمعاصر', preview: 'أول عشر صفحات تتضمن مقدمة شاملة...' },
      { id: 2, title: 'تاريخ الحضارة الإسلامية', author: 'فاطمة علي', price: 200, image: '/api/placeholder/200/250', category: 'تاريخ', description: 'دراسة معمقة لتاريخ الحضارة الإسلامية', preview: 'الفصل الأول يتناول نشأة الحضارة...' }
    ]);
    
    setInterviews([
      { id: 1, title: 'لقاء مع الكاتب أحمد محمد', date: '2024-01-15', duration: '45 دقيقة', status: 'منشور', type: 'فيديو', description: 'مقابلة شاملة مع الكاتب حول أعماله الأدبية' },
      { id: 2, title: 'حوار حول الأدب المعاصر', date: '2024-01-20', duration: '30 دقيقة', status: 'مسودة', type: 'بودكاست', description: 'نقاش عن اتجاهات الأدب المعاصر' }
    ]);
    
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" />;
  }

  const handleDelete = (type, id) => {
    if (window.confirm('هل أنت متأكد من الحذف؟')) {
      if (type === 'books') {
        setBooks(books.filter(book => book.id !== id));
      } else if (type === 'interviews') {
        setInterviews(interviews.filter(interview => interview.id !== id));
      } else if (type === 'orders') {
        deleteOrder(id);
      }
    }
  };

  const handleEdit = (type, item) => {
    setEditingItem({ type, ...item });
    setShowModal(true);
  };

  const renderOrderModal = () => {
    if (!editingItem || editingItem.type !== 'orders') return null;
    
    return (
      <div className="modal-overlay" onClick={() => setShowModal(false)}>
        <div className="modal-content order-modal" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h3>تفاصيل الطلب #{editingItem.id}</h3>
            <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="order-info">
              <div className="info-section">
                <h4>معلومات العميل</h4>
                <p><strong>الاسم:</strong> {editingItem.customerName}</p>
                <p><strong>البريد الإلكتروني:</strong> {editingItem.email}</p>
                <p><strong>الهاتف:</strong> {editingItem.phone}</p>
                <p><strong>العنوان:</strong> {editingItem.address}, {editingItem.city}</p>
                <p><strong>الرمز البريدي:</strong> {editingItem.postalCode}</p>
                <p><strong>طريقة الدفع:</strong> {editingItem.paymentMethod === 'cash' ? 'الدفع عند الاستلام' : 
                  editingItem.paymentMethod === 'fawry' ? 'فوري باي' : 'فودافون كاش'}</p>
              </div>
              
              <div className="info-section">
                <h4>تفاصيل الطلب</h4>
                <p><strong>التاريخ:</strong> {editingItem.date}</p>
                <p><strong>الحالة:</strong> 
                  <span className={`status ${editingItem.status === 'مكتمل' ? 'completed' : 'processing'}`}>
                    {editingItem.status}
                  </span>
                </p>
                <p><strong>عدد الكتب:</strong> {editingItem.itemsCount}</p>
                <p><strong>المجموع:</strong> {editingItem.total} جنيه</p>
              </div>
              
              <div className="info-section">
                <h4>الكتب المطلوبة</h4>
                <div className="order-items">
                  {editingItem.items && editingItem.items.map(item => (
                    <div key={item.id} className="order-item">
                      <span className="item-title">{item.title}</span>
                      <span className="item-quantity">الكمية: {item.quantity}</span>
                      <span className="item-price">{item.price * item.quantity} جنيه</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="modal-actions">
              {editingItem.status === 'قيد المعالجة' && (
                <button 
                  className="btn btn-success"
                  onClick={() => {
                    updateOrderStatus(editingItem.id, 'مكتمل');
                    setShowModal(false);
                  }}
                >
                  تأكيد الطلب
                </button>
              )}
              <button 
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleSave = (formData) => {
    if (editingItem.type === 'books') {
      if (editingItem.id) {
        setBooks(books.map(book => book.id === editingItem.id ? { ...book, ...formData } : book));
      } else {
        setBooks([...books, { ...formData, id: Date.now() }]);
      }
    } else if (editingItem.type === 'interviews') {
      if (editingItem.id) {
        setInterviews(interviews.map(interview => interview.id === editingItem.id ? { ...interview, ...formData } : interview));
      } else {
        setInterviews([...interviews, { ...formData, id: Date.now() }]);
      }
    }
    setShowModal(false);
    setEditingItem(null);
  };

  const renderBooksTab = () => (
    <div className="tab-content">
      <div className="tab-header">
        <h2>إدارة الكتب</h2>
        <button 
          className="btn btn-primary"
          onClick={() => handleEdit('books', {})}
        >
          إضافة كتاب جديد
        </button>
      </div>
      
      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>الصورة</th>
              <th>العنوان</th>
              <th>المؤلف</th>
              <th>السعر</th>
              <th>التصنيف</th>
              <th>الوصف</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {books.map(book => (
              <tr key={book.id}>
                <td><img src={book.image} alt={book.title} className="table-image" /></td>
                <td>{book.title}</td>
                <td>{book.author}</td>
                <td>{book.price} جنيه</td>
                <td>{book.category}</td>
                <td className="description-cell">{book.description}</td>
                <td>
                  <button 
                    className="btn btn-sm btn-secondary"
                    onClick={() => handleEdit('books', book)}
                  >
                    تعديل
                  </button>
                  <button 
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete('books', book.id)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderInterviewsTab = () => (
    <div className="tab-content">
      <div className="tab-header">
        <h2>إدارة المقابلات</h2>
        <button 
          className="btn btn-primary"
          onClick={() => handleEdit('interviews', {})}
        >
          إضافة مقابلة جديدة
        </button>
      </div>
      
      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>العنوان</th>
              <th>النوع</th>
              <th>التاريخ</th>
              <th>المدة</th>
              <th>الحالة</th>
              <th>الوصف</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {interviews.map(interview => (
              <tr key={interview.id}>
                <td>{interview.title}</td>
                <td>
                  <span className={`interview-type ${interview.type}`}>
                    {interview.type}
                  </span>
                </td>
                <td>{interview.date}</td>
                <td>{interview.duration}</td>
                <td>
                  <span className={`status ${interview.status === 'منشور' ? 'published' : 'draft'}`}>
                    {interview.status}
                  </span>
                </td>
                <td className="description-cell">{interview.description}</td>
                <td>
                  <button 
                    className="btn btn-sm btn-secondary"
                    onClick={() => handleEdit('interviews', interview)}
                  >
                    تعديل
                  </button>
                  <button 
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete('interviews', interview.id)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderOrdersTab = () => (
    <div className="tab-content">
      <div className="tab-header">
        <h2>إدارة الطلبات</h2>
      </div>
      
      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>رقم الطلب</th>
              <th>اسم العميل</th>
              <th>البريد الإلكتروني</th>
              <th>المجموع</th>
              <th>الحالة</th>
              <th>التاريخ</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {realOrders.map(order => (
              <tr key={order.id}>
                <td>#{order.id}</td>
                <td>{order.customerName}</td>
                <td>{order.email}</td>
                <td>{order.total} جنيه</td>
                <td>
                  <span className={`status ${order.status === 'مكتمل' ? 'completed' : 'processing'}`}>
                    {order.status}
                  </span>
                </td>
                <td>{order.date}</td>
                <td>
                  <button 
                    className="btn btn-sm btn-info"
                    onClick={() => handleEdit('orders', order)}
                  >
                    عرض
                  </button>
                  {order.status === 'قيد المعالجة' && (
                    <button 
                      className="btn btn-sm btn-success"
                      onClick={() => updateOrderStatus(order.id, 'مكتمل')}
                    >
                      تأكيد
                    </button>
                  )}
                  <button 
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete('orders', order.id)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>لوحة التحكم الإدارية</h1>
        <button className="btn btn-secondary" onClick={logout}>
          تسجيل الخروج
        </button>
      </div>

      <div className="dashboard-tabs">
        <button 
          className={`tab-btn ${activeTab === 'books' ? 'active' : ''}`}
          onClick={() => setActiveTab('books')}
        >
          الكتب
        </button>
        <button 
          className={`tab-btn ${activeTab === 'interviews' ? 'active' : ''}`}
          onClick={() => setActiveTab('interviews')}
        >
          المقابلات
        </button>
        <button 
          className={`tab-btn ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          الطلبات
        </button>
      </div>

      <div className="dashboard-content">
        {activeTab === 'books' && renderBooksTab()}
        {activeTab === 'interviews' && renderInterviewsTab()}
        {activeTab === 'orders' && renderOrdersTab()}
      </div>

      {showModal && (
        <AdminModal
          item={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}
    </div>
  );
};

const AdminModal = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    title: item.title || '',
    author: item.author || '',
    price: item.price || '',
    category: item.category || '',
    image: item.image || '',
    description: item.description || '',
    preview: item.preview || '',
    date: item.date || '',
    duration: item.duration || '',
    status: item.status || 'مسودة',
    type: item.type || 'فيديو',
    file: null,
    fileName: ''
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        file: file,
        fileName: file.name
      });
    }
  };

  const getAcceptedFileTypes = () => {
    switch (formData.type) {
      case 'مستند':
        return '.pdf,.doc,.docx';
      case 'بودكاست':
        return '.mp3,.wav,.m4a';
      case 'فيديو':
        return '.mp4,.avi,.mov,.mkv';
      default:
        return '';
    }
  };

  const getFileTypeLabel = () => {
    switch (formData.type) {
      case 'مستند':
        return 'رفع ملف PDF أو Word';
      case 'بودكاست':
        return 'رفع ملف صوتي (MP3, WAV)';
      case 'فيديو':
        return 'رفع ملف فيديو (MP4, AVI)';
      default:
        return 'رفع ملف';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>{item.id ? 'تعديل' : 'إضافة'} {item.type === 'books' ? 'كتاب' : 'مقابلة'}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          {item.type === 'books' ? (
            <>
              <div className="form-group">
                <label>العنوان</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({...formData, title: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>المؤلف</label>
                <input
                  type="text"
                  value={formData.author}
                  onChange={(e) => setFormData({...formData, author: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>السعر</label>
                <input
                  type="number"
                  value={formData.price}
                  onChange={(e) => setFormData({...formData, price: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>التصنيف</label>
                <input
                  type="text"
                  value={formData.category}
                  onChange={(e) => setFormData({...formData, category: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>رابط الصورة</label>
                <input
                  type="url"
                  value={formData.image}
                  onChange={(e) => setFormData({...formData, image: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>الوصف</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  rows="3"
                  placeholder="وصف مختصر للكتاب"
                />
              </div>
              <div className="form-group">
                <label>صور معاينة أول 10 صفحات</label>
                <input
                  type="text"
                  value={formData.preview}
                  onChange={(e) => setFormData({...formData, preview: e.target.value})}
                  placeholder="روابط الصور مفصولة بفاصلة (مثال: image1.jpg, image2.jpg, ...)"
                />
                <small className="form-help">
                  يمكنك إدراج عدة روابط صور مفصولة بفاصلة لعرض صفحات الكتاب
                </small>
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label>العنوان</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({...formData, title: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>التاريخ</label>
                <input
                  type="date"
                  value={formData.date}
                  onChange={(e) => setFormData({...formData, date: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>المدة</label>
                <input
                  type="text"
                  value={formData.duration}
                  onChange={(e) => setFormData({...formData, duration: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>نوع المقابلة</label>
                <select
                  value={formData.type}
                  onChange={(e) => setFormData({...formData, type: e.target.value, file: null, fileName: ''})}
                >
                  <option value="فيديو">فيديو</option>
                  <option value="بودكاست">بودكاست</option>
                  <option value="مستند">مستند</option>
                </select>
              </div>
              
              {/* قسم رفع الملفات */}
              <div className="form-group file-upload-section">
                <label>{getFileTypeLabel()}</label>
                <div className="file-upload-container">
                  <input
                    type="file"
                    accept={getAcceptedFileTypes()}
                    onChange={handleFileUpload}
                    className="file-input"
                    id="file-upload"
                  />
                  <label htmlFor="file-upload" className="file-upload-btn">
                    <i className="fas fa-upload"></i>
                    اختر ملف
                  </label>
                  {formData.fileName && (
                    <div className="file-info">
                      <i className="fas fa-file"></i>
                      <span className="file-name">{formData.fileName}</span>
                      <button 
                        type="button" 
                        className="remove-file-btn"
                        onClick={() => setFormData({...formData, file: null, fileName: ''})}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>
                <div className="file-upload-help">
                  {formData.type === 'مستند' && (
                    <small>يمكنك رفع ملفات PDF أو Word. الحد الأقصى: 10MB</small>
                  )}
                  {formData.type === 'بودكاست' && (
                    <small>يمكنك رفع ملفات صوتية MP3, WAV, M4A. الحد الأقصى: 50MB</small>
                  )}
                  {formData.type === 'فيديو' && (
                    <small>يمكنك رفع ملفات فيديو MP4, AVI, MOV. الحد الأقصى: 100MB</small>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>الوصف</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  rows="3"
                  placeholder="وصف مختصر للمقابلة"
                />
              </div>
              {/* معلومات إضافية حسب نوع الملف */}
              {formData.type === 'مستند' && (
                <div className="form-group">
                  <label>عدد الصفحات</label>
                  <input
                    type="number"
                    value={formData.pages || ''}
                    onChange={(e) => setFormData({...formData, pages: e.target.value})}
                    placeholder="عدد صفحات المستند"
                  />
                </div>
              )}
              
              {(formData.type === 'بودكاست' || formData.type === 'فيديو') && (
                <div className="form-group">
                  <label>اسم الضيف</label>
                  <input
                    type="text"
                    value={formData.guest || ''}
                    onChange={(e) => setFormData({...formData, guest: e.target.value})}
                    placeholder="اسم ضيف المقابلة"
                  />
                </div>
              )}
              
              <div className="form-group">
                <label>الحالة</label>
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({...formData, status: e.target.value})}
                >
                  <option value="مسودة">مسودة</option>
                  <option value="منشور">منشور</option>
                </select>
              </div>
            </>
          )}
          
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              إلغاء
            </button>
            <button type="submit" className="btn btn-primary">
              حفظ
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminDashboard;
